import { createDomain } from 'effector-root';

const domain = createDomain('Payment Report (Page)');

export const onPageStarted = domain.event();